import { isEmpty } from "lodash-es";
import React from "react";
import { getAddSizeUnit } from "../../utils/size";
import { classnames, } from "../../utils/text";
import { ColCard } from "../ContentLayout";
import DataComponent from "../DataComponent";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
// import PerfectScrollbar from 'react-perfect-scrollbar';


const CardList = ({
  list = [],
  fields = [],
  isLoading,
  isTable = true,
  className
  // height
}) => {
  return <div
    className={classnames("custom-list card-list", className)}
    style={{
      // ...height ? { height: getAddSizeUnit(height) } : {}
    }}
  >
    {/* <PerfectScrollbar> */}
    {isLoading ?
      <Loading /> :
      isEmpty(list) ? <NoData /> :
        list.map((data, idx) => (
          isTable ?
            <ColCard type="light" key={idx}>
              <div className="display-table">
                <div className="display-table-row">
                  {fields.map((field, i) =>
                    <div
                      className={`display-table-cell ${classnames(field.className)}`}
                      key={i}
                      style={{
                        ...field.width ? { width: getAddSizeUnit(field.width) } : {}
                      }}
                    >
                      <DataComponent field={field} data={data} />
                    </div>
                  )}
                </div>
              </div>
            </ColCard>
            :
            <ColCard type="light" key={idx}>
              {fields.map((field, i) =>
                <div
                  className={`${classnames(field.className)}`}
                  key={i}
                  style={{
                    ...field.width ? { width: getAddSizeUnit(field.width) } : {}
                  }}
                >
                  <DataComponent field={field} data={data} />
                </div>
              )}
            </ColCard>
        ))
    }
    {/* </PerfectScrollbar> */}
  </div >
}
export default CardList